(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-block"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
      var carousel_brand = $('[data-owl]');
      if (carousel_brand.length) {
         carousel_brand.each(function(index, el) {
            $(this).owlCarousel($(this).data('owl'));
         });
	  }
}    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .sale_of");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                vertical: true,
                autoplay: true,
                prevArrow: false,
                nextArrow: false
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-featured-collection"] && !Shopify.designMode) return;
  try {
    
function process_owl_event(evt) {
      var  carousel_pro = $('[data-owl-carousel]');
	  carousel_pro = $('.widget-product .product_scroll'); 
      if (carousel_pro.length) {
         carousel_pro.each(function(index, el) {
            $(this).owlCarousel($(this).data('owl-carousel'));
         });
	  }
}

process_owl_event();

$(document)
 .on( 'shopify:section:load', process_owl_event )
 .on( 'shopify:section:unload', process_owl_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-brands-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('.po-brands__toggle');
    if (!toggle) return;
    var container = toggle.closest('.po-brands');
    if (!container) return;
    var extras = container.querySelectorAll('.po-brands__item--extra');
    if (!extras.length) return;
    var expanded = container.getAttribute('data-expanded') !== 'true';
    extras.forEach(function(el) { el.classList.toggle('is-visible', expanded); });
    toggle.textContent = expanded ? 'Show less' : 'View more brands';
    container.setAttribute('data-expanded', expanded ? 'true' : 'false');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-problem-tiles"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('click', function(e) {
    var a = e.target.closest('a[href="#po-problem-tiles"]');
    if (!a) return;
    var target = document.getElementById('po-problem-tiles');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var grid = document.querySelector('.po-problem__grid');
  if (!grid) return;
  grid.addEventListener('click', function(e) {
    var tile = e.target.closest('.po-problem__tile');
    if (!tile) return;
    var problem = tile.getAttribute('data-problem-key');
    if (!problem) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('quiz:tile-click', { detail: { problem: problem } }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-quiz-engine"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('po-quiz-engine');
  if (!section) return;
  var sectionId = section.getAttribute('data-section-id');
  var dataEl = document.getElementById('po-quiz-data-' + sectionId);
  if (!dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var problems = DATA.problems || {};
  var recs = DATA.recommendations || [];

  /* ── DOM refs ── */
  var panel = document.getElementById('po-quiz-panel');
  var entry = document.getElementById('po-quiz-entry');
  var heroImg = document.getElementById('po-quiz-hero-img');
  var titleEl = document.getElementById('po-quiz-title');
  var subtitleEl = document.getElementById('po-quiz-subtitle');
  var baquacilWarn = document.getElementById('po-quiz-baquacil-warn');
  var slidersEl = document.getElementById('po-quiz-sliders');
  var selectorsEl = document.getElementById('po-quiz-selectors');
  var getResultsBtn = document.getElementById('po-quiz-get-results');
  var diagnosisEl = document.getElementById('po-quiz-diagnosis');
  var resultsEl = document.getElementById('po-quiz-results');
  var resultsList = document.getElementById('po-quiz-results-list');
  var browseLink = document.getElementById('po-quiz-browse-link');
  var proTip = document.getElementById('po-quiz-pro-tip');
  var backBtn = document.getElementById('po-quiz-back');
  var phSlider = document.getElementById('po-quiz-ph');
  var clSlider = document.getElementById('po-quiz-cl');
  var alkSlider = document.getElementById('po-quiz-alk');
  var clLabelEl = document.getElementById('po-quiz-cl-label');
  var clScaleEl = document.getElementById('po-quiz-cl-scale');
  var alkScaleEl = document.getElementById('po-quiz-alk-scale');

  /* ── Defaults & state ── */
  var defaultGallons = (function() {
    var active = section.querySelector('.po-quiz__pill.po-quiz__pill--active[data-gallons]');
    if (active) return parseInt(active.getAttribute('data-gallons'));
    var first = section.querySelector('[data-gallons]');
    return first ? parseInt(first.getAttribute('data-gallons')) : 15000;
  })();

  var state = {
    path: null,
    problem: null,
    system: 'chlorine',
    gallons: defaultGallons,
    ph: 7.4,
    cl: 2.0,
    alk: 100,
    baqLevel: 40
  };

  /* ── Helpers ── */
  function commas(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function calcDose(rec, gallons) {
    var per10k = parseFloat(rec.per10k) || 0;
    var mult = parseFloat(rec.multiplier) || 1;
    if (!per10k) return 0;
    return Math.ceil((gallons / 10000) * per10k * mult);
  }

  function calcAmt(rec, gallons) {
    var amount = calcDose(rec, gallons);
    if (!amount) return '';
    var unit = rec.unit || '';
    if (unit === 'tab') return amount + ' tablet' + (amount !== 1 ? 's' : '');
    return amount + (unit ? ' ' + unit : '');
  }

  function renderDose(rec, gallons) {
    var template = rec.dose_template || '';
    var amt = calcAmt(rec, gallons) || 'as directed';
    return template.replace(/\{amt\}/g, amt).replace(/\{sz\}/g, commas(gallons));
  }

  function recsByContext(context) {
    return recs
      .filter(function(r) { return r.context === context; })
      .sort(function(a, b) { return (a.order_hint || 0) - (b.order_hint || 0); });
  }

  function scrollToEl(el) {
    var navHeight = 0;
    var candidates = document.querySelectorAll('header, .header-wrapper, [role="banner"], .shopify-section-header, .announcement-bar');
    candidates.forEach(function(h) {
      var s = getComputedStyle(h);
      if (s.position === 'sticky' || s.position === 'fixed') {
        navHeight = Math.max(navHeight, h.getBoundingClientRect().height);
      }
    });
    if (navHeight === 0) navHeight = 70;
    var y = el.getBoundingClientRect().top + window.pageYOffset - navHeight - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  /* ── UI helpers ── */
  function showPanel(path) {
    state.path = path;
    panel.style.display = '';
    if (entry) entry.style.display = 'none';
    resultsEl.style.display = 'none';
    diagnosisEl.style.display = 'none';
    diagnosisEl.innerHTML = '';
    getResultsBtn.style.display = '';
    getResultsBtn.disabled = false;
    baquacilWarn.style.display = 'none';
    browseLink.style.display = 'none';
    proTip.style.display = 'none';
    heroImg.style.display = 'none';
    slidersEl.style.display = path === 'calculator' ? '' : 'none';
    selectorsEl.style.display = '';

    heroImg.innerHTML = '';

    if (path === 'tile') {
      var p = problems[state.problem] || {};
      titleEl.textContent = p.title || '';
      subtitleEl.textContent = p.subtitle || '';
      if (p.image_src) {
        var img = document.createElement('img');
        img.src = p.image_src;
        if (p.image_srcset) img.srcset = p.image_srcset;
        img.sizes = '(min-width: 768px) 768px, 100vw';
        img.alt = p.title || '';
        img.width = 1344;
        img.height = 768;
        img.loading = 'lazy';
        heroImg.appendChild(img);
        heroImg.style.display = '';
      }
      getResultsBtn.textContent = 'Get My Recommendations';
    } else if (path === 'calculator') {
      titleEl.textContent = 'Your Water Readings';
      subtitleEl.textContent = 'Adjust the sliders to match your test results.';
      getResultsBtn.textContent = 'Get My Recommendations';
    } else if (path === 'starter') {
      titleEl.textContent = 'Your Pool Starter Kit';
      subtitleEl.textContent = 'Everything your pool needs to stay clean and safe.';
      getResultsBtn.textContent = 'Build My Starter Kit';
    }

    scrollToEl(panel);
  }

  function hidePanel() {
    panel.style.display = 'none';
    if (entry) entry.style.display = '';
  }

  function renderResults(resolvedRecs) {
    getResultsBtn.style.display = 'none';
    resultsEl.style.display = '';
    resultsList.innerHTML = '';

    var isBaq = state.system === 'baquacil';
    baquacilWarn.style.display = isBaq ? 'flex' : 'none';

    resolvedRecs.forEach(function(rec, i) {
      var unitPriceCents = parseInt(rec.price_cents) || 0;
      var dose = renderDose(rec, state.gallons);
      var unitPriceDisplay = '$' + (rec.price || (unitPriceCents / 100).toFixed(2));
      var priceDisplay = unitPriceDisplay;

      var div = document.createElement('div');
      div.className = 'po-quiz__rec';
      div.innerHTML =
        '<span class="po-quiz__rec-num">' + (i + 1) + '</span>' +
        '<div class="po-quiz__rec-info">' +
          '<p class="po-quiz__rec-name"><a href="' + rec.product_url + '" target="_blank" rel="noopener noreferrer">' + rec.product_name + '</a></p>' +
          '<p class="po-quiz__rec-dose">' + (dose || '') + '</p>' +
          (rec.tip ? '<p class="po-quiz__rec-tip">&#128161; ' + rec.tip + '</p>' : '') +
        '</div>' +
        '<div class="po-quiz__rec-action">' +
          '<span class="po-quiz__rec-price">' + priceDisplay + '</span>' +
          '<a class="po-quiz__rec-view btn" href="' + rec.product_url + '" target="_blank" rel="noopener noreferrer">View product</a>' +
        '</div>';
      resultsList.appendChild(div);
    });

    if (state.path === 'tile') {
      var p = problems[state.problem] || {};
      if (p.browse_url) {
        browseLink.href = p.browse_url;
        browseLink.textContent = p.browse_label || 'Browse all products';
        browseLink.style.display = '';
      }
    }
    if (state.path === 'starter') {
      proTip.textContent = '\uD83D\uDCA1 Pro tip: Once you have test readings, come back and use our Water Test Calculator for exact dosing.';
      proTip.style.display = '';
    }

    scrollToEl(selectorsEl);
  }

  /* Calculator path — thresholds are scientific constants. Product picks come
     from recommendation blocks keyed by context (calc_ph_high, calc_ph_low,
     calc_cl_low_shock,
     calc_cl_low_tabs, calc_baq_low, calc_alk_high, calc_default_chlorine,
     calc_default_baquacil). */
  function runCalculator() {
    var diags = [];
    var picked = [];
    var ph = state.ph, cl = state.cl, alk = state.alk;
    var isBaq = state.system === 'baquacil';

    /* pH */
    if (ph > 7.8) {
      var steps = Math.ceil((ph - 7.5) / 0.2);
      diags.push({ level: 'bad', icon: '\u26A0\uFE0F', text: '<strong>pH is HIGH (' + ph.toFixed(1) + ')</strong> - causes scale buildup and makes sanitizer less effective. Fix this first.' });
      picked.push({ context: 'calc_ph_high', dose_suffix: ' (' + steps + ' doses)' });
    } else if (ph > 7.6) {
      diags.push({ level: 'warn', icon: '\u26A0\uFE0F', text: '<strong>pH is SLIGHTLY HIGH (' + ph.toFixed(1) + ')</strong> - still acceptable (7.2-7.8) but not ideal.' });
    } else if (ph < 7.2) {
      var steps2 = Math.ceil((7.4 - ph) / 0.2);
      diags.push({ level: 'bad', icon: '\u26A0\uFE0F', text: '<strong>pH is LOW (' + ph.toFixed(1) + ')</strong> - water is acidic, causes eye irritation and corrodes equipment.' });
      picked.push({ context: 'calc_ph_low', dose_suffix: ' (' + steps2 + ' doses)' });
    } else if (ph < 7.4) {
      diags.push({ level: 'warn', icon: '\u26A0\uFE0F', text: '<strong>pH is SLIGHTLY LOW (' + ph.toFixed(1) + ')</strong> - still acceptable (7.2-7.8) but not ideal.' });
    } else {
      diags.push({ level: 'good', icon: '\u2705', text: '<strong>pH is IDEAL (' + ph.toFixed(1) + ')</strong> - in the perfect 7.4-7.6 range.' });
    }

    /* Sanitizer */
    if (isBaq) {
      if (state.baqLevel < 30) {
        diags.push({ level: 'bad', icon: '\uD83D\uDD34', text: '<strong>Biguanide Sanitizer is LOW (' + state.baqLevel + ' ppm)</strong> - pool is vulnerable. Add sanitizer immediately.' });
        picked.push({ context: 'calc_baq_low' });
      } else if (state.baqLevel > 50) {
        diags.push({ level: 'warn', icon: '\u26A0\uFE0F', text: '<strong>Biguanide Sanitizer is HIGH (' + state.baqLevel + ' ppm)</strong> - reduce usage. Let it drop naturally.' });
      } else {
        diags.push({ level: 'good', icon: '\u2705', text: '<strong>Biguanide Sanitizer is GOOD (' + state.baqLevel + ' ppm)</strong> - in the ideal 30-50 ppm range.' });
      }
    } else {
      if (cl < 1) {
        diags.push({ level: 'bad', icon: '\uD83D\uDD34', text: '<strong>Chlorine is LOW (' + cl.toFixed(1) + ' ppm)</strong> - pool is vulnerable to algae and bacteria. Shock immediately.' });
        picked.push({ context: 'calc_cl_low_shock' });
        picked.push({ context: 'calc_cl_low_tabs' });
      } else if (cl > 5) {
        diags.push({ level: 'bad', icon: '\u26A0\uFE0F', text: '<strong>Chlorine is HIGH (' + cl.toFixed(1) + ' ppm)</strong> - can irritate skin. Stop adding chlorine, wait for it to drop below 4 ppm before swimming.' });
      } else if (cl > 4) {
        diags.push({ level: 'warn', icon: '\u26A0\uFE0F', text: '<strong>Chlorine is SLIGHTLY HIGH (' + cl.toFixed(1) + ' ppm)</strong> - still safe but at the top end.' });
      } else {
        diags.push({ level: 'good', icon: '\u2705', text: '<strong>Chlorine is IDEAL (' + cl.toFixed(1) + ' ppm)</strong> - in the perfect 1-4 ppm range.' });
      }
    }

    /* Alkalinity */
    var alkHigh = isBaq ? 150 : 120;
    if (alk < 80) {
      diags.push({ level: 'warn', icon: '\u26A0\uFE0F', text: '<strong>Alkalinity is LOW (' + alk + ' ppm)</strong> - pH will bounce around. Use baking soda to raise it to 80+ ppm.' });
    } else if (alk > alkHigh) {
      diags.push({ level: 'warn', icon: '\u26A0\uFE0F', text: '<strong>Alkalinity is HIGH (' + alk + ' ppm)</strong> - can cause cloudy water. Use pH Down to lower it gradually toward ' + alkHigh + ' ppm.' });
      picked.push({ context: 'calc_alk_high' });
    } else {
      diags.push({ level: 'good', icon: '\u2705', text: '<strong>Alkalinity is IDEAL (' + alk + ' ppm)</strong> - buffers your pH nicely in the ' + (isBaq ? '80-150' : '80-120') + ' ppm range.' });
    }

    /* If nothing to fix, recommend maintenance */
    if (picked.length === 0) {
      picked.push({ context: isBaq ? 'calc_default_baquacil' : 'calc_default_chlorine' });
    }

    /* Show diagnosis */
    diagnosisEl.style.display = '';
    diagnosisEl.innerHTML = diags.map(function(d) {
      return '<div class="po-quiz__diag-item po-quiz__diag-item--' + d.level + '">' + d.icon + ' ' + d.text + '</div>';
    }).join('');

    /* Resolve picks to actual recommendation blocks (dedupe by variant) */
    var resolved = [];
    var seen = {};
    picked.forEach(function(pick) {
      var candidates = recsByContext(pick.context);
      candidates.forEach(function(r) {
        if (seen[r.variant_id]) return;
        seen[r.variant_id] = true;
        /* Clone so we can append dose_suffix without mutating the shared rec */
        var clone = Object.assign({}, r);
        if (pick.dose_suffix && clone.dose_template) clone.dose_template = clone.dose_template + pick.dose_suffix;
        resolved.push(clone);
      });
    });

    renderResults(resolved);
  }

  /* ── Path: Starter Kit ── */
  function runStarterKit() {
    var ctx;
    if (state.system === 'baquacil') ctx = 'starter_baquacil';
    else if (state.system === 'saltwater') ctx = 'starter_saltwater';
    else ctx = 'starter_chlorine';
    renderResults(recsByContext(ctx));
  }

  /* ── Path: Tile click ── */
  function runTileFix() {
    var ctx = state.problem || '';
    var sys = state.system;
    var filtered = recs
      .filter(function(r) { return r.context === ctx; })
      .filter(function(r) { return !r.pool_system || r.pool_system === 'any' || r.pool_system === sys; })
      .sort(function(a, b) { return (a.order_hint || 0) - (b.order_hint || 0); });
    renderResults(filtered);
  }

  /* ── Slider updates ── */
  if (phSlider) phSlider.addEventListener('input', function() {
    state.ph = this.value / 10;
    document.getElementById('po-quiz-ph-val').textContent = state.ph.toFixed(1);
  });
  if (clSlider) clSlider.addEventListener('input', function() {
    if (state.system === 'baquacil') {
      state.baqLevel = parseInt(this.value);
      document.getElementById('po-quiz-cl-val').textContent = state.baqLevel;
    } else {
      state.cl = this.value / 10;
      document.getElementById('po-quiz-cl-val').textContent = state.cl.toFixed(1);
    }
  });
  if (alkSlider) alkSlider.addEventListener('input', function() {
    state.alk = parseInt(this.value);
    document.getElementById('po-quiz-alk-val').textContent = state.alk;
  });

  function updateSanitizerSlider(system) {
    if (!clSlider || !clLabelEl || !clScaleEl) return;
    if (system === 'baquacil') {
      clLabelEl.textContent = 'Biguanide Sanitizer (ppm)';
      clSlider.min = '0'; clSlider.max = '100'; clSlider.step = '1'; clSlider.value = '40';
      state.baqLevel = 40;
      document.getElementById('po-quiz-cl-val').textContent = '40';
      clScaleEl.innerHTML = '<span style="left:0">0</span><span style="left:30%">30</span><span style="left:50%">50</span><span>100</span>';
      clSlider.style.background = 'linear-gradient(to right, #E41217 0%, #FFA500 22%, #14B726 30%, #14B726 50%, #FFA500 58%, #E41217 70%, #E41217 100%)';
      if (alkSlider && alkScaleEl) {
        alkScaleEl.innerHTML = '<span style="left:0">0</span><span style="left:40%">80</span><span style="left:75%">150</span><span>200</span>';
        alkSlider.style.background = 'linear-gradient(to right, #E41217 0%, #FFA500 32%, #14B726 40%, #14B726 75%, #FFA500 82%, #E41217 100%)';
      }
    } else {
      clLabelEl.textContent = 'Free Chlorine (ppm)';
      clSlider.min = '0'; clSlider.max = '100'; clSlider.step = '1'; clSlider.value = '20';
      state.cl = 2.0;
      document.getElementById('po-quiz-cl-val').textContent = '2.0';
      clScaleEl.innerHTML = '<span style="left:0">0</span><span style="left:10%">1</span><span style="left:40%">4</span><span>10</span>';
      clSlider.style.background = '';
      if (alkSlider && alkScaleEl) {
        alkScaleEl.innerHTML = '<span style="left:0">0</span><span style="left:40%">80</span><span style="left:60%">120</span><span>200</span>';
        alkSlider.style.background = '';
      }
    }
  }

  /* ── Events ── */
  document.addEventListener('quiz:tile-click', function(e) {
    state.problem = e.detail.problem;
    showPanel('tile');
  });

  section.querySelectorAll('.po-quiz__entry-btn').forEach(function(btn) {
    btn.addEventListener('click', function() { showPanel(this.getAttribute('data-path')); });
  });

  function resetResults() {
    resultsEl.style.display = 'none';
    diagnosisEl.style.display = 'none';
    diagnosisEl.innerHTML = '';
    resultsList.innerHTML = '';
    browseLink.style.display = 'none';
    proTip.style.display = 'none';
    baquacilWarn.style.display = 'none';
    getResultsBtn.style.display = '';
    getResultsBtn.disabled = false;
    getResultsBtn.textContent = state.path === 'starter' ? 'Build My Starter Kit' : 'Get My Recommendations';
  }

  section.addEventListener('click', function(e) {
    var systemPill = e.target.closest('.po-quiz__pill[data-system]');
    if (systemPill) {
      section.querySelectorAll('.po-quiz__pill[data-system]').forEach(function(p) { p.classList.remove('po-quiz__pill--active'); });
      systemPill.classList.add('po-quiz__pill--active');
      state.system = systemPill.getAttribute('data-system');
      updateSanitizerSlider(state.system);
      resetResults();
      return;
    }
    var sizePill = e.target.closest('.po-quiz__pill[data-gallons]');
    if (sizePill) {
      section.querySelectorAll('.po-quiz__pill[data-gallons]').forEach(function(p) { p.classList.remove('po-quiz__pill--active'); });
      sizePill.classList.add('po-quiz__pill--active');
      state.gallons = parseInt(sizePill.getAttribute('data-gallons'));
      resetResults();
      return;
    }
  });

  getResultsBtn.addEventListener('click', function() {
    if (state.path === 'calculator') runCalculator();
    else if (state.path === 'starter') runStarterKit();
    else if (state.path === 'tile') runTileFix();
  });

  backBtn.addEventListener('click', hidePanel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .home-slider-wrap ul");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
             centerMode: true,
              variableWidth: true,
              centerPadding: '60px',
              slidesToShow: _slick.data('slick').slidesToShow,
              slidesToScroll: 1,
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"] && !Shopify.designMode) return;
  try {
    

function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .product-slider");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              slidesToShow: _slick.data('slick').slidesToShow,
              slidesToScroll: 1,
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on(   'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();
})();
